import React, { useState } from "react";
import { Button, Input } from "@windmill/react-ui";
import { Link, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../Redux/userReducer";
import Error from "../components/form/Error";
import LabelArea from "../components/form/LabelArea";
import ImageLight from "../../client/assets/FInalLogo.png";
import './EditProfile.css'

const ResetPassword = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState({
    password: '',
    confirmPassword: ''
  });

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  console.log('Token:', token);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    if (name === 'newPassword') {
      setNewPassword(value);
      if (errors.password) setErrors({ ...errors, password: '' });
    } else {
      setConfirmPassword(value);
      // Clear error when typing
      if (errors.confirmPassword) setErrors({ ...errors, confirmPassword: '' });
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate password not empty
    if (!newPassword.trim()) {
      Swal.fire({
        icon: "error",
        title: "Password Required",
        text: "Please enter a new password",
      });
      return;
    }

    // Validate minimum 8 characters
    if (newPassword.length < 8) {
      Swal.fire({
        icon: "error",
        title: "Password Too Short",
        text: "Password must be at least 8 characters long",
      });
      return;
    }

    // Validate password match
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "New password and confirm password do not match.",
      });
      return;
    }

    const data = {
      newPass: newPassword,
      resetToken: token,
    };

    try {
      const response = await dispatch(resetPassword({ ...data, history }));
      if (response.error) {
        throw new Error(response.error.message);
      }

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Password Reset Failed",
        text: error?.response?.data?.message || "An error occurred while resetting your password",
      });
    }
  };
  console.log(confirmPassword);
  return (
    <div className="flex items-center min-h-screen p-6 bg-gray-50">
      <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl">
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2 operLogoOuter">
            <img
              aria-hidden="true"
              className="operatorLogo"
              src={ImageLight}
              alt="Office"
            />
          </div>
          <main className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
            <div className="w-full">
              <h1 className="mb-4 text-xl font-semibold text-gray-700">
                Reset password
              </h1>

              <form
                onSubmit={handleSubmit}
              >
                <LabelArea label="Password" />
                <Input
                  name="newPassword"
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={handlePasswordChange}
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                />
                <div className="mt-6"></div>
                <LabelArea label="Confirm Password" />
                <Input
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={handlePasswordChange}
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                />

                <Button
                  type="submit"
                  block
                  className="mt-4 h-12 newBtnColor"
                >
                  Reset
                </Button>
              </form>
              <p className="mt-1">
                <Link
                  className="text-sm font-medium noTextDecor hover:underline"
                  to="/"
                >
                  Click here to go to Homepage
                </Link>
              </p>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
